<template>
  <div class="campaign-page">
    <a
      v-if="phase === 'active' || phase === 'upcoming'"
      href="#packages"
      class="campaign-top-banner"
    >
      <img
        src="@/assets/images/header/banner.gif"
        alt="空前钜惠，年终大促双11，全年充值抄底价，5折起，查看充值套餐"
      />
    </a>
    <header class="activity-header">
      <div class="header-inner">
        <span class="site-logo" aria-hidden="true">
          <img src="@/assets/images/logo.png" alt="" />
        </span>
        <nav aria-label="活动导航">
          <router-link to="/materialDownload">素材代下</router-link>
          <router-link to="/pay">充值优惠</router-link>
          <a href="#packages" class="current"
            ><img
              src="@/assets/images/activity/charge.gif"
              alt="双11限时钜惠，查看充值套餐"
          /></a>
        </nav>
        <router-link to="/materialDownload" class="back-link"
          >返回下载首页</router-link
        >
      </div>
    </header>

    <section class="activity-hero" aria-label="双十一充值活动">
      <h1>
        <img
          class="activity-title"
          src="@/assets/images/activity11/activityImage.png"
          alt="11.11狂欢，惠战到底"
        />
      </h1>
      <p class="activity-date">活动时间：{{ campaign.dateLabel }}</p>
    </section>

    <main class="activity-main">
      <section class="activity-countdown" aria-label="活动时间">
        <div class="countdown-heading">
          <strong>{{ statusTitle }}</strong>
          <span v-if="phase === 'active' || phase === 'upcoming'">{{
            phase === "upcoming" ? "距离活动开始" : "距离今日结束"
          }}</span>
        </div>
        <div
          v-if="phase === 'active' || phase === 'upcoming'"
          class="countdown"
          aria-live="off"
        >
          <span v-for="(part, key) in remaining" :key="key" class="time-part"
            ><b>{{ part }}</b
            ><small>{{ timeLabels[key] }}</small></span
          >
        </div>
        <router-link v-else to="/pay" class="normal-pay-link"
          >查看日常充值优惠 &gt;</router-link
        >
      </section>

      <section id="packages" class="packages-section">
        <div class="section-heading">
          <h2>双十一充值钜惠</h2>
          <p>双11限时加赠，选择适合自己的充值金额</p>
        </div>
        <div class="package-grid featured-grid">
          <article
            v-for="(item, index) in list.slice(0, 3)"
            :key="item.price"
            :class="[
              'package-card',
              { recommended: index === 1, maximum: index === 2 },
            ]"
          >
            <span class="bonus-rate">{{ item.badge }}</span>
            <p class="package-price">充值 {{ formatAmount(item.price) }} 元</p>
            <p class="package-note">双11大额充值特惠</p>
            <div class="gift-line">
              <span>赠送</span><strong>{{ formatAmount(item.addprice) }}</strong
              ><span>元</span>
            </div>
            <p v-if="item.oldprice > 0" class="old-gift">
              原赠 {{ formatAmount(item.oldprice) }} 元
            </p>
            <div class="total-line">
              <span>合计到账</span
              ><strong>¥{{ formatAmount(item.price + item.addprice) }}</strong>
            </div>
            <el-button
              :disabled="phase !== 'active' || isPaying"
              class="package-button"
              @click="openPayPop(index)"
              >{{ purchaseLabel
              }}<span v-if="phase === 'active'" aria-hidden="true">
                ↗</span
              ></el-button
            >
          </article>
        </div>
        <div class="flexible-heading">
          <h3>灵活补给，按需充值</h3>
          <span>从小额体验到项目储备，总有适合的一档。</span>
        </div>
        <div class="package-grid flexible-grid">
          <article
            v-for="(item, index) in list.slice(3)"
            :key="item.price"
            class="package-card compact-card"
          >
            <span class="bonus-rate">{{ item.badge }}</span>
            <p class="package-price">充值 {{ formatAmount(item.price) }} 元</p>
            <p class="package-note">双11充值特惠</p>
            <div class="gift-line">
              <span>赠送</span><strong>{{ formatAmount(item.addprice) }}</strong
              ><span>元</span>
            </div>
            <p v-if="item.oldprice > 0" class="old-gift">
              原赠 {{ formatAmount(item.oldprice) }} 元
            </p>
            <div class="total-line">
              <span>合计到账</span
              ><strong>¥{{ formatAmount(item.price + item.addprice) }}</strong>
            </div>
            <el-button
              :disabled="phase !== 'active' || isPaying"
              class="package-button"
              @click="openPayPop(index + 3)"
              >{{ purchaseLabel }}</el-button
            >
          </article>
        </div>
      </section>
    </main>

    <router-link to="/materialCenter" class="search-guide">
      <img
        src="@/assets/images/activity/img_guide.png"
        alt="站内素材搜索，体验一站式下载"
      />
    </router-link>

    <Dialog
      v-if="dialogTableVisible"
      :dialogVisible="dialogTableVisible"
      :dialogPaying="isPaying"
      :curPreferential="currentPreferential"
      :currentPrice="currentPrice"
      :currentCouponId="0"
      :currentPayType="currentPayType"
      @closeDialog="closePayPop"
      @onPay="changePay"
      @success="refreshAccount"
    />
  </div>
</template>

<script>
import Dialog from "./module/dialog.vue";
import { message } from "@/utils/resetMessage";
import { getTempUser, getToken } from "@/utils/storage";
import { getSessionUser } from "@/api/auth";
import {
  DOUBLE_ELEVEN,
  RECHARGE_PACKAGES,
  getCampaignPhase,
  getCampaignCountdown,
  hasMemberSession,
} from "@/utils/doubleEleven";

export default {
  components: { Dialog },
  data() {
    return {
      campaign: DOUBLE_ELEVEN,
      list: RECHARGE_PACKAGES,
      now: Date.now(),
      clockTimer: null,
      timeLabels: { hours: "时", minutes: "分", seconds: "秒" },
      currentPrice: 0,
      currentPreferential: 0,
      currentPayType: "alipay",
      dialogTableVisible: false,
      isPaying: false,
    };
  },
  computed: {
    phase() {
      return getCampaignPhase(this.now);
    },
    remaining() {
      return getCampaignCountdown(this.now);
    },
    statusTitle() {
      return {
        upcoming: "双十一预热中",
        active: "双十一加赠进行中",
        ended: "本次活动已结束",
        disabled: "活动暂未开放",
      }[this.phase];
    },
    statusDescription() {
      return {
        upcoming: "先选好心仪套餐，11 月 1 日正式开启。",
        active: "活动期间充值，享对应档位专属加赠。",
        ended: "感谢关注，日常充值仍可继续使用。",
        disabled: "你可以前往日常充值页面查看套餐。",
      }[this.phase];
    },
    purchaseLabel() {
      return {
        upcoming: "11 月 1 日开抢",
        active: "立即充值",
        ended: "活动已结束",
        disabled: "暂未开放",
      }[this.phase];
    },
  },
  mounted() {
    document.body.classList.add("double-eleven-page");
    this.clockTimer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    document.body.classList.remove("double-eleven-page");
    clearInterval(this.clockTimer);
  },
  methods: {
    formatAmount(value) {
      return Number(value).toLocaleString("zh-CN");
    },
    openPayPop(index) {
      // 重新读时钟和会话，避免跨结束边界或登录过期后仍使用旧状态。
      this.now = Date.now();
      if (
        getCampaignPhase(this.now) !== "active" ||
        this.dialogTableVisible ||
        !this.list[index]
      )
        return;
      if (!hasMemberSession(getToken(), getTempUser())) {
        message.info({
          message: "请先登录，登录后将返回双十一活动页",
          duration: 3000,
          offset: 80,
        });
        this.$router.push({
          path: "/login",
          query: { redirect: this.campaign.path },
        });
        return;
      }
      this.currentPrice = this.list[index].price;
      this.currentPreferential = this.list[index].addprice;
      this.currentPayType = "alipay";
      this.isPaying = false;
      this.dialogTableVisible = true;
    },
    closePayPop() {
      this.dialogTableVisible = false;
      this.isPaying = false;
    },
    changePay(flag) {
      this.isPaying = flag;
    },
    async refreshAccount() {
      try {
        const account = await getSessionUser({});
        this.$store.dispatch("setUserInfo", account);
      } catch (error) {
        message.info({
          message: "支付已成功，账户信息暂未刷新，请稍后到个人中心查看",
          duration: 4000,
          offset: 80,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.campaign-page {
  min-height: 100vh;
  background: #e12826;
  color: #333;
  font-family: Arial, "Microsoft YaHei", sans-serif;
}
.campaign-page * {
  box-sizing: border-box;
}
.campaign-page a {
  text-decoration: none;
}
.campaign-top-banner {
  display: flex;
  justify-content: center;
  height: 44px;
  overflow: hidden;
  background: #ea2d3e;
}
.campaign-top-banner img {
  flex-shrink: 0;
  width: 1920px;
  max-width: none;
  height: 44px;
}
.activity-header {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.header-inner {
  height: 70px;
  max-width: 1240px;
  padding: 0 20px;
  margin: auto;
  display: flex;
  align-items: center;
}
.site-logo {
  display: flex;
  flex-shrink: 0;
  margin-right: 60px;
  visibility: hidden;
}
.site-logo img {
  width: 175px;
  height: auto;
}
.header-inner nav {
  display: flex;
  height: 100%;
  gap: 36px;
  align-items: center;
}
.header-inner nav a {
  display: flex;
  height: 100%;
  align-items: center;
  font-size: 14px;
  color: #333;
  border-bottom: 3px solid transparent;
  padding-top: 3px;
}
.header-inner nav a:hover {
  color: #f33b28;
}
.header-inner nav a.current {
  color: #f33b28;
  border-bottom-color: #f33b28;
  font-weight: bold;
}
.header-inner nav a.current img {
  width: 102px;
  height: 40px;
  object-fit: contain;
}
.back-link {
  margin-left: auto;
  font-size: 13px;
  color: #888;
}
.back-link:hover {
  color: #f33b28;
}
.activity-hero {
  height: 360px;
  background: #e12826 url(~@/assets/images/activity/bg1.png) center top / cover
    no-repeat;
  isolation: isolate;
  position: relative;
  text-align: center;
  padding: 2px 20px 0;
}
.activity-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(180deg, rgba(225, 40, 38, 0) 20%, #e12826 100%);
}
.activity-hero h1 {
  margin: 0;
  height: 350px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.activity-title {
  display: block;
  width: 1020px;
  max-width: 100%;
  height: auto;
}
.activity-date {
  position: absolute;
  bottom: 17px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 7px 20px;
  border-radius: 18px;
  background: rgba(155, 17, 15, 0.3);
  white-space: nowrap;
  font-size: 14px;
  color: #fff0c3;
  font-weight: bold;
}
.activity-main {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  padding: 18px 0 36px;
}
.activity-countdown {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 68px;
  background: #cc2422;
  border: 1px solid #f8785f;
  border-radius: 8px;
  padding: 14px 24px;
}
.countdown-heading {
  display: flex;
  align-items: center;
  gap: 18px;
}
.countdown-heading strong {
  color: #fff0c3;
  font-size: 19px;
}
.countdown-heading > span {
  font-size: 14px;
  color: #ffddbc;
}
.countdown {
  display: flex;
  gap: 9px;
}
.time-part {
  display: flex;
  align-items: center;
  gap: 7px;
}
.time-part b {
  display: inline-block;
  min-width: 34px;
  padding: 5px 6px;
  background: #fff0bb;
  color: #c42e21;
  border-radius: 4px;
  font-size: 20px;
  font-variant-numeric: tabular-nums;
  text-align: center;
}
.time-part small {
  color: #ffe0b9;
  font-size: 13px;
}
.normal-pay-link {
  color: #fff0c3;
  font-size: 14px;
}
.packages-section {
  padding: 36px 0 42px;
  scroll-margin-top: 25px;
}
.section-heading {
  margin-bottom: 27px;
  text-align: center;
}
h2 {
  color: #fff0c3;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.45;
}
.section-heading > p {
  color: #ffdfb0;
  font-size: 15px;
  margin: 12px 0 0;
}
.package-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}
.package-card {
  position: relative;
  overflow: hidden;
  padding: 46px 24px 26px;
  border: 1px solid #edc782;
  background: #fffdf5;
  border-radius: 9px;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}
.package-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px #775a3910;
}
.bonus-rate {
  position: absolute;
  top: 0;
  right: 0;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  font-weight: 700;
  background: #ff392e;
  color: #fff;
  padding: 0 13px;
  border-radius: 0 8px 0 8px;
  white-space: nowrap;
}
.package-price {
  margin: 0;
  color: #292929;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.package-note {
  display: inline-block;
  margin: 14px 0 0;
  padding: 5px 13px;
  border-radius: 18px;
  background: #fff3e2;
  color: #d19845;
  font-size: 12px;
  line-height: 18px;
}
.gift-line {
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 7px;
  margin: 16px 0 0;
  color: #ff3026;
  font-size: 16px;
  line-height: 1.2;
  white-space: nowrap;
}
.gift-line strong {
  font-size: 48px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: -1px;
}
.old-gift {
  margin: 17px 0 0;
  color: #b69759;
  font-size: 14px;
  line-height: 20px;
  text-decoration: line-through;
}
.total-line {
  border-top: 1px dashed #e2d5c7;
  padding-top: 17px;
  margin-top: 23px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  color: #89786a;
}
.total-line strong {
  color: #89786a;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
}
.package-button.el-button {
  display: block;
  width: 100%;
  background: #c83729;
  border: 1px solid #c83729;
  color: white;
  font-size: 13px;
  height: 44px;
  margin-top: 20px;
  border-radius: 6px;
}
.package-button.el-button:not(.is-disabled):hover {
  background: #c83729;
  border-color: #c83729;
  color: white;
}
.package-button.el-button.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.recommended .package-button.el-button {
  background: #c83729;
  border-color: #c83729;
  color: white;
}
.flexible-heading {
  margin: 36px 0 20px;
  display: flex;
  align-items: baseline;
  gap: 16px;
}
h3 {
  color: #fff0c3;
  margin: 0;
  font-size: 18px;
}
.flexible-heading > span {
  font-size: 12px;
  color: #ffdfb0;
}
.compact-card {
  padding: 42px 24px 23px;
}
.compact-card .package-price {
  font-size: 22px;
}
.compact-card .gift-line strong {
  font-size: 42px;
}
.compact-card .total-line {
  margin-top: 20px;
  padding-top: 15px;
}
.compact-card .package-button {
  height: 39px;
  margin-top: 17px;
}
.search-guide {
  display: block;
  background: #fb8165;
  overflow: hidden;
}
.search-guide img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 1920px;
  margin: auto;
}
.campaign-page a:focus-visible,
.campaign-page button:focus-visible {
  outline: 2px solid #ffcb67;
  outline-offset: 3px;
}

@media (max-width: 1050px) {
  .activity-countdown {
    flex-wrap: wrap;
    gap: 12px 20px;
  }
  .countdown-heading strong {
    font-size: 17px;
  }
  .header-inner nav {
    gap: 24px;
  }
  .site-logo {
    margin-right: 35px;
  }
  .package-card {
    padding: 44px 16px 24px;
  }
  .package-price {
    font-size: 22px;
  }
  .gift-line {
    gap: 5px;
  }
  .gift-line strong {
    font-size: 40px;
  }
}
@media (max-width: 760px) {
  .campaign-top-banner {
    height: 36px;
  }
  .campaign-top-banner img {
    width: 1571px;
    height: 36px;
  }
  .header-inner {
    height: 60px;
    padding: 0 16px;
  }
  .site-logo {
    margin-right: auto;
  }
  .site-logo img {
    width: 138px;
  }
  .header-inner nav {
    display: none;
  }
  .back-link {
    font-size: 12px;
    margin-left: 20px;
  }
  .activity-hero {
    height: 220px;
    padding: 8px 0 0;
    background-size: auto 100%;
    overflow: hidden;
  }
  .activity-hero h1 {
    height: 185px;
  }
  .activity-title {
    width: 100%;
    max-width: 600px;
    height: auto;
  }
  .activity-date {
    font-size: 11px;
    bottom: 15px;
  }
  .activity-main {
    width: auto;
    max-width: none;
    margin: 0 14px;
    padding-top: 14px;
    padding-bottom: 0;
  }
  .activity-countdown {
    justify-content: center;
    padding: 15px 10px;
    gap: 12px;
  }
  .countdown-heading {
    width: 100%;
    justify-content: center;
    gap: 12px;
  }
  .countdown-heading strong {
    font-size: 15px;
  }
  .countdown-heading > span {
    font-size: 12px;
  }
  .countdown {
    gap: 9px;
  }
  .time-part {
    gap: 6px;
  }
  .time-part b {
    font-size: 18px;
    min-width: 34px;
    padding: 4px 6px;
  }
  .time-part small {
    font-size: 11px;
  }
  .packages-section {
    padding: 30px 0;
  }
  h2 {
    font-size: 24px;
  }
  .section-heading > p {
    font-size: 12px;
  }
  .package-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .package-card {
    padding: 42px 24px 24px;
  }
  .bonus-rate {
    height: 25px;
    line-height: 25px;
    font-size: 10px;
    padding: 0 8px;
  }
  .package-price {
    font-size: 24px;
  }
  .gift-line strong {
    font-size: 48px;
  }
  .flexible-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .flexible-heading {
    flex-direction: column;
    gap: 8px;
    margin-top: 30px;
  }
  .flexible-heading > span {
    font-size: 11px;
  }
  .compact-card {
    padding: 38px 10px 18px;
  }
  .compact-card .package-price {
    font-size: 18px;
  }
  .compact-card .package-note {
    margin-top: 10px;
    padding: 4px 10px;
    font-size: 10px;
  }
  .compact-card .gift-line {
    margin-top: 13px;
    font-size: 12px;
    gap: 4px;
  }
  .compact-card .gift-line strong {
    font-size: 32px;
  }
  .compact-card .old-gift {
    margin-top: 12px;
    font-size: 11px;
  }
  .compact-card .total-line {
    font-size: 10px;
    gap: 3px;
  }
  .compact-card .total-line strong {
    font-size: 13px;
  }
  .compact-card .package-button {
    font-size: 11px;
    padding: 10px 3px;
  }
  .search-guide img {
    width: 760px;
    max-width: none;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (max-width: 359px) {
  .flexible-grid {
    grid-template-columns: 1fr;
  }
  .countdown-heading {
    flex-direction: column;
    gap: 7px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .package-card {
    transition: none;
  }
  .package-card:hover {
    transform: none;
  }
}
</style>

<style lang="scss">
body.double-eleven-page {
  min-width: 0;
}
</style>
